<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>Firmas</h1>
  <div mat-dialog-content>
    <mat-spinner *ngIf="loading"></mat-spinner>
    <mat-form-field *ngIf="!loading" class="full-width">
      <input type="text" #physician matInput placeholder="Firma uno" formControlName="PhysicianSignatureOne" [matAutocomplete]="physicianSignatureOne">
      <mat-autocomplete #physicianSignatureOne="matAutocomplete" [displayWith]="filterCompletePhysiciansOne.displayFn">
        <mat-option *ngFor="let physician of filteredPhysiciansOptionsOne | async" [value]="physician">
          {{physician.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field *ngIf="!loading" class="full-width">
      <input type="text" #physician matInput placeholder="Firma dos" formControlName="PhysicianSignatureTwo" [matAutocomplete]="physicianSignatureTwo">
      <mat-autocomplete #physicianSignatureTwo="matAutocomplete" [displayWith]="filterCompletePhysiciansTwo.displayFn">
        <mat-option *ngFor="let physician of filteredPhysiciansOptionsTwo | async" [value]="physician">
          {{physician.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field *ngIf="!loading" class="full-width">
      <input type="text" #physician matInput placeholder="Firma tres" formControlName="PhysicianSignatureThree" [matAutocomplete]="physicianSignatureThree">
      <mat-autocomplete #physicianSignatureThree="matAutocomplete" [displayWith]="filterCompletePhysiciansThree.displayFn">
        <mat-option *ngFor="let physician of filteredPhysiciansOptionsThree | async" [value]="physician">
          {{physician.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>


    <mat-form-field *ngIf="!loading" class="full-width">
      <input type="text" #physician matInput placeholder="Firma cuatro" formControlName="PhysicianSignatureFour" [matAutocomplete]="physicianSignatureFour">
      <mat-autocomplete #physicianSignatureFour="matAutocomplete" [displayWith]="filterCompletePhysiciansFour.displayFn">
        <mat-option *ngFor="let physician of filteredPhysiciansOptionsFour | async" [value]="physician">
          {{physician.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field *ngIf="!loading" class="full-width">
      <input type="text" #physician matInput placeholder="Firma cinco" formControlName="PhysicianSignatureFive" [matAutocomplete]="physicianSignatureFive">
      <mat-autocomplete #physicianSignatureFive="matAutocomplete" [displayWith]="filterCompletePhysiciansFive.displayFn">
        <mat-option *ngFor="let physician of filteredPhysiciansOptionsFive | async" [value]="physician">
          {{physician.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field *ngIf="!loading" class="full-width">
      <input type="text" #physician matInput placeholder="Firma sies" formControlName="PhysicianSignatureSix" [matAutocomplete]="physicianSignatureSix">
      <mat-autocomplete #physicianSignatureSix="matAutocomplete" [displayWith]="filterCompletePhysiciansSix.displayFn">
        <mat-option *ngFor="let physician of filteredPhysiciansOptionsSix | async" [value]="physician">
          {{physician.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

  </div>
  <div class="clearfix">
    <div *ngIf="!loading" class="pull-right">
      <button mat-button type="submit">Aceptar</button>
      <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
  </div>
</form>


